"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnsiteRequest = void 0;
class OnsiteRequest {
    constructor(props) {
        this.adminActions = props?.adminActions || null;
        this.att_category = props?.att_category || null;
        this.att_date = props?.att_date || null;
        this.cm = props?.cm || null;
        this.complain_text = props?.complain_text || null;
        this.complain = props?.complain || null;
        this.corporate = props?.corporate || null;
        this.country = props?.country || null;
        this.cuit = props?.cuit || null;
        this.dependant_uid = props?.dependant_uid || null;
        this.destino_final = props?.destino_final || null;
        this.diagnostico = props?.diagnostico || null;
        this.dni = props?.dni || null;
        this.dob = props?.dob || null;
        this.doc_eval = props?.doc_eval || null;
        this.dt_cierre = props?.dt_cierre || null;
        this.dt_complain = props?.dt_complain || null;
        this.dt_user_cancel = props?.dt_user_cancel || null;
        this.dt = props?.dt || null;
        this.epicrisis = props?.epicrisis || null;
        this.fullname = props?.fullname || null;
        this.hc = props?.hc || null;
        this.id = props?.id || null;
        this.incidente_id = props?.incidente_id || null;
        this.notas = props?.notas || null;
        this.notes = props?.notes || null;
        this.origin = props?.origin || null;
        this.payment_data = props?.payment_data || null;
        this.practices = props?.practices || [];
        this.promesa = props?.promesa || null;
        this.pronesa = props?.pronesa || null;
        this.reposo = props?.reposo || null;
        this.request_date = props?.request_date || null;
        this.scheduleId = props?.scheduleId || null;
        this.sex = props?.sex || null;
        this.shiftId = props?.shiftId || null;
        this.social_work = props?.social_work || null;
        this.speciality = props?.speciality || null;
        this.status_derivacion = props?.status_derivacion || null;
        this.status = props?.status || null;
        this.track_id = props?.track_id || null;
        this.timestamps = props?.timestamps;
        this.transcripcion = props?.transcripcion || null;
        this.uid = props?.uid || null;
        this.uma_eval = props?.uma_eval || null;
        this.user_lat = props?.user_lat || null;
        this.user_lon = props?.user_lon || null;
        this.user = props?.user || null;
        this.ws = props?.ws || null;
        this.user_data = props?.user_data || null;
        this.affiliateNumber = props?.affiliateNumber || null;
        this.event_country = props?.event_country || null;
        this.provider_uid = props?.provider_uid || null;
        this.specialist_referral = props?.specialist_referral || null;
        this.technicalIssues = props?.technicalIssues || null;
        this.observation = props?.observation || null;
    }
}
exports.OnsiteRequest = OnsiteRequest;
